import React, { useReducer, createContext, useContext } from "react";

const initialState = {
  isOpen: true,
  expandVisible: false,
  routes: {},
};

const ACTIONS = {
  SET_ROUTES: "SET_ROUTES",
  RESET_ROUTES: "RESET_ROUTES",
  TOGGLE: "TOGGLE",
  CLOSE: "CLOSE",
  OPEN: "OPEN",
  SET_HAMBURGER_VISIBLE: "SET_HAMBURGER_VISIBLE",
};

const reducer = (state, data) => {
  switch (data.action) {
    case ACTIONS.SET_ROUTES: {
      const { payload } = data;
      const { name, routes, order } = payload;

      const newRoutes = { ...state.routes, [name]: { routes, order } };

      return {
        ...state,
        routes: newRoutes,
      };
    }

    case ACTIONS.OPEN: {
      const newState = { ...state };
      return {
        ...newState,
        isOpen: true,
      };
    }

    case ACTIONS.CLOSE: {
      const newState = { ...state };
      return {
        ...newState,
        isOpen: false,
      };
    }

    case ACTIONS.SET_HAMBURGER_VISIBLE: {
      const { payload } = data;
      const { value } = payload;
      return {
        ...state,
        expandVisible: value,
      };
    }

    case ACTIONS.TOGGLE: {
      const newState = { ...state };
      return {
        ...newState,
        isOpen: !state.isOpen,
      };
    }

    case ACTIONS.RESET_ROUTES: {
      return {
        ...state,
        routes: {},
        settingsRoutes: [],
      };
    }

    default:
      throw new Error();
  }
};

const SidebarContext = createContext(initialState);

const SidebarProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <SidebarContext.Provider value={stateAndDispatch}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);

export { SidebarContext, SidebarProvider, ACTIONS };
